import React, { useEffect, useState, useCallback } from 'react';
import { Card, Form, Row, Col, Button } from 'react-bootstrap';
import PageHeader from 'shared/page-header';
import Layout from '../../../wrappers/layout';
import IndicatorCard from '../components/indicator-card';
import { userStore } from '../../../store/UserStore';
import Loader from '../../../shared/common/loader';
import CustomerHttp from '../services/customer.service';
import authentication from './../../../Redux/auth/auth.reducer';
import OtpInput from 'react-otp-input';
import Imodal from 'shared/common/modal';
import CustomerOnboardingHttp from '../services/customer.service';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Toast from '../../../shared/common/toast';

interface PropsType {
  customerId: any;
  pan: any;
}

const SelectGstin: React.FC<PropsType> = (customerId, pan) => {
  // eslint-disable-next-line
  const [user, setUser, customer] = userStore((state: any) => [
    state.user,
    state.setUser,
    state.customer,
  ]);

  const [loading, setLoading] = useState<any>(true);
  const [gstnList, setGstnList] = useState<any>([]);
  const [gstn, setGstn] = useState<any>('');
  const [gstnDeatil, setGstnDeatils] = useState<any>({});
  const [canConfirm, setCanConfirm] = useState<any>(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isConfirm, setConfirm] = useState<any>(false);
  const [isCreateLoading, setCreateLoading] = React.useState(false);
  const history = useHistory();

  useEffect((): any => {
    if (customerId.customerId) {
      getGstn(customerId.customerId, customerId.pan);
    }
  }, [customerId]);

  // useEffect((): any => {
  //   console.log(customerId.customerId);
  //   console.log(customerId.pan);

  //   }, []);

  const getGstn = async (customerId, panNumber) => {
    try {
      const data = {
        customerId: customerId,
        pan: panNumber,
      };
      const res: any = await CustomerOnboardingHttp.getGstns(data);
      if (res.status === 200 && res.data.data) {
        setGstnList(res.data.data.gstins);
        // if(customer.customerType !== 'IND'){
        //     const ress = res.data.data.gstins.map((d) => {
        //         return {...d, account:customer.accounts.find((acc) => d.gstin === acc.kyc.gstin.value)}
        //     });
        //     setGstnList(res);
        // }
      } else {
        toast.error('Something went wrong');
      }
      setLoading(false);
    } catch (e: any) {
      console.log(e);
      setLoading(false);
      toast.error('Something went wrong');
    }
  };

  const getGstnDetails = async () => {
    if (!gstn) return;
    setLoading(true);
    try {
      const data = {
        customerId: customerId.customerId,
        gstin: gstn,
      };
      const res: any = await CustomerOnboardingHttp.getGstnDetails(data);
      if (res.status === 200 && res.data.data) {
        setGstnDeatils(res.data.data);
        // setTitle('Account Details');
        setConfirm(true);
      } else {
        toast.error('Something went wrong');
      }
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.log(e);
      toast.error('Something went wrong');
    }
  };

  const createSubAccount = async () => {
    setCreateLoading(true);
    try {
      const data = {
        customerId: customerId.customerId,
        kyc: { gstin: { value: gstn } },
      };

      const res: any = await CustomerOnboardingHttp.createAccount(data,user?.userId);
      if (res) {
        toast.success('New account create successfuly.');
        history.push('/customers');
      }
      setCreateLoading(false);
    } catch (err: any) {
      console.log(err);
      toast.error(err.data.errors[0].title);
      setCreateLoading(false);
    }
  };

  return (
    <>
      <Toast />
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className='row justify-content-md-center'>
            <div className='col-md-6 col-md-offset-3'>
              <Card>
                <Card.Body className='p-5 pb-0 mb-3'>
                  <div>
                    <div className='text-center mb-3'>
                      <Card.Title>Create New Customer Account</Card.Title>
                      <Card.Subtitle>
                        Select a GSTIN to proceed with creating an account
                      </Card.Subtitle>
                    </div>
                    <div className='p-5'>
                      {isConfirm ? (
                        <Row>
                          <Col md={12}>
                            <Form.Group className='mb-3' controlId='upiName'>
                              <Form.Label>GSTIN</Form.Label>
                              <Form.Control
                                type='text'
                                value={gstnDeatil.gstin}
                                disabled
                              />
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <Form.Group className='mb-3' controlId='upiName'>
                              <Form.Label>Address</Form.Label>
                              <Form.Control
                                type='text'
                                value={gstnDeatil?.address?.address1}
                                disabled
                              />
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <Form.Group className='mb-3' controlId='upiName'>
                              <Form.Label>Pin Code</Form.Label>
                              <Form.Control
                                type='text'
                                value={gstnDeatil?.address?.pinCode}
                                disabled
                              />
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <Form.Group className='mb-3' controlId='upiName'>
                              <Form.Label>City</Form.Label>
                              <Form.Control
                                type='text'
                                value={gstnDeatil?.address?.city}
                                disabled
                              />
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <Form.Group className='mb-3' controlId='upiName'>
                              <Form.Label>State</Form.Label>
                              <Form.Control
                                type='text'
                                value={gstnDeatil?.address?.state}
                                disabled
                              />
                            </Form.Group>
                          </Col>
                          <div className='col-md-12'>
                            <Button
                              disabled={isCreateLoading}
                              className='w-100 mt-3'
                              variant='primary'
                              type='button'
                              onClick={createSubAccount}
                            >
                              {!isCreateLoading ? (
                                'Create'
                              ) : (
                                <div
                                  className='spinner-border text-white'
                                  role='status'
                                >
                                  <span className='visually-hidden'>
                                    Loading...
                                  </span>
                                </div>
                              )}
                            </Button>
                          </div>
                        </Row>
                      ) : (
                        <>
                          <Col md={12} className='mt-3'>
                            <ul className='list-group'>
                              {gstnList.map((gstn, idx) => (
                                <li className='list-group-item d-flex justify-content-between align-items-start'>
                                  <input
                                    className='form-check-input'
                                    onChange={() => setGstn(gstn.gstin)}
                                    type='radio'
                                    name='gstin'
                                    value=''
                                    aria-label='...'
                                  />
                                  <div className='ms-2 me-auto'>
                                    <div className='fw-bold'>{gstn.gstin}</div>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </Col>
                          <div className='col-md-12'>
                            <Button
                              disabled={isLoading}
                              className='w-100 mt-3'
                              variant='primary'
                              type='button'
                              onClick={getGstnDetails}
                            >
                              {!isLoading ? (
                                'Confirm'
                              ) : (
                                <div
                                  className='spinner-border text-white'
                                  role='status'
                                >
                                  <span className='visually-hidden'>
                                    Loading...
                                  </span>
                                </div>
                              )}
                            </Button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SelectGstin;
